import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import DocumentTitle from 'utils/DocumentTitle';

import SpecPagesAllTags from 'components/SpecialPages/Common/SpecPagesAllTags';

import SpecialPagesList from './SpecialPagesList';
import SpecialPagesView from './SpecialPagesView';

const routes = [
  {
    path: '/spec',
    exact: true,
    component: () => <Redirect from="/" to="/spec/all" />
  },
  {
    path: '/spec/all',
    component: SpecialPagesList,
    exact: true
  },
  {
    path: '/spec/tag/:tag',
    component: SpecialPagesList
  },
  {
    path: '/spec/:id',
    component: SpecialPagesView
  }
];

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    exact={route.exact || false}
    render={props => {
      // pass the sub-routes down to keep nesting
      if (route.pageTitle) {
        return (
          <DocumentTitle title={route.pageTitle}>
            <route.component {...props} routes={route.routes} />
          </DocumentTitle>
        );
      }
      return <route.component {...props} routes={route.routes} />;
    }}
  />
);

// eslint-disable-next-line react/prefer-stateless-function
class SpecPages extends Component {
  render() {
    return (
      <React.Fragment>
        <SpecPagesAllTags />
        <Switch>
          {routes.map(route => (
            <RouteWithSubRoutes
              key={`SpecPagesRoute${route.path}`}
              {...route}
            />
          ))}
        </Switch>
      </React.Fragment>
    );
  }
}

export default SpecPages;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/SpecPages/index.js